import { FormattedMessage } from "react-intl";

import { Button } from "@ps-design-system/components/Button";
import {
  MarketingCard,
  MarketingCardDescription,
  MarketingCardFooter,
  MarketingCardHeader,
  MarketingCardTitle,
} from "@ps-design-system/components/cards/MarketingCard";

type HostHubMetricsProps = {
  email?: string;
  firstName?: string;
  lastName?: string;
  SSOid?: string;
};

const HostHubMetrics = ({
  email,
  firstName,
  lastName,
  SSOid,
}: HostHubMetricsProps) => {
  const dashboardUrl = "/host/dashboard";
  // Typeform hidden fields are passed via the URL fragment; URLSearchParams
  // gives us proper encoding for names/emails with spaces or special chars.
  const surveyParams = new URLSearchParams({
    ssoid: SSOid ?? "",
    last_name: lastName ?? "",
    first_name: firstName ?? "",
    email: email ?? "",
    user_id: SSOid ?? "",
  });
  const surveyUrl = `https://peerspaceforms.typeform.com/to/BB7ksgbo#${surveyParams.toString()}`;
  const handleDashboardClick = () => {
    window.location.assign(dashboardUrl);
  };
  const handleSurveyClick = () => {
    window.open(surveyUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="tw-flex tw-flex-col tw-gap-[32px] lg:tw-flex-row">
      <MarketingCard className="tw-max-w-[352px] tw-gap-16 tw-rounded-8 tw-border-0 tw-p-24 tw-shadow-xl">
        <MarketingCardHeader className="tw-mb-0 tw-gap-8">
          <MarketingCardTitle>
            <FormattedMessage
              defaultMessage="Metrics dashboard beta"
              id="host_hub.metrics.dashboard_card.title"
            />
          </MarketingCardTitle>
          <MarketingCardDescription>
            <FormattedMessage
              defaultMessage="We recently launched a beta test to get feedback on a metrics dashboard. We are allowing a limited amount of hosts to test."
              id="host_hub.metrics.dashboard_card.description"
            />
          </MarketingCardDescription>
        </MarketingCardHeader>
        <MarketingCardFooter className="tw-pt-0">
          <Button appearance="purple" onClick={handleDashboardClick}>
            <FormattedMessage
              defaultMessage="View dashboard"
              id="host_hub.metrics.dashboard_card.cta"
            />
          </Button>
        </MarketingCardFooter>
      </MarketingCard>

      <MarketingCard className="tw-max-w-[352px] tw-gap-16 tw-rounded-8 tw-border-0 tw-p-24 tw-shadow-xl">
        <MarketingCardHeader className="tw-mb-0 tw-gap-8">
          <MarketingCardTitle>
            <FormattedMessage
              defaultMessage="Fill out our metrics survey"
              id="host_hub.metrics.survey_card.title"
            />
          </MarketingCardTitle>
          <MarketingCardDescription>
            <FormattedMessage
              defaultMessage="Give us feedback about what you would like to see in the metrics dashboard. Your feedback will help craft what we build."
              id="host_hub.metrics.survey_card.description"
            />
          </MarketingCardDescription>
        </MarketingCardHeader>
        <MarketingCardFooter className="tw-pt-0">
          <Button appearance="black" onClick={handleSurveyClick}>
            <FormattedMessage
              defaultMessage="Fill out survey"
              id="host_hub.metrics.survey_card.cta"
            />
          </Button>
        </MarketingCardFooter>
      </MarketingCard>
    </div>
  );
};

export default HostHubMetrics;
